import { useEffect } from "react";
import { useLogosStore } from "../store";

export const useResetStore = () => {
  const reset = useLogosStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
